import React, { useEffect } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import AgenticAi from "./pages/AgenticAi";
import AIDebtRecovery from "./pages/AIDebtRecovery";
import CaseStudies from "./pages/CaseStudies";


import RequestForQuote from "./pages/RequestForQuote";
import Grievance from "./pages/Grievance";
import BeWorkFromHomeReady from "./pages/BeWorkFromHomeReady";
import FAQs from "./pages/FAQs";
import OutcessClients from "./pages/OutcessClients";
import About from "./pages/About";
import BusinessPartners from "./pages/BusinessPartners";
import Ideology from "./pages/Ideology";
import Careers from "./pages/Careers";
import CurrentOpenings from "./pages/CurrentOpenings";
import Gallery from "./pages/Gallery";
import Industries from "./pages/Industries/Industries";
import CloudSolutions from "./pages/CloudSolutions";
import OmniChannelMarketing from "./pages/Omni-ChannelMarketing";
import BusinessProdSolution from "./pages/BusinessProdSolution";
import BusinessOutsource from "./pages/BusinessOutsource";
import CustomerEngmntSolution from "./pages/CustomerEngmntSolution";
import NotFound from "./pages/NotFound";
import ISOQualityPolicyStatement from "./pages/ISOQualityPolicyStatement";
import ISMSPolicyStatement from "./pages/ISMSPolicyStatement";
import DataPolicy from "./pages/DataPolicy";
import Hire from "./pages/Hire/Hire";
import HireForm from "./pages/Hire/HireForm";
import Usa from "./pages/USA/Usa";
import AmlSolution from "./pages/AmlSolution";
import AIGovernanceLifecycle from "./pages/AIGovernanceLifecycle";
import USAServices from "./pages/USA/USAServices";
import USAContactus from "./pages/USA/USAContactUs";
import USAboutUs from "./pages/USA/USAboutsUs";
import USIndustries from "./pages/USA/USIndustries";
import ErrorBoundary from "./pages/USA/USA-Components/errorBoundry";
import CaseStudyDetails from "./pages/CaseStudyDetails";

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: "ease",
      offset: 80,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const path = window.location.pathname;

        if (data.country === "US" && !path.startsWith("/us")) {
          window.location.replace("/us");
        }
      })
      .catch(() => { });
  }, []);

  return (
    <div className="App">
      <Router basename="/">
        <ScrollToTop />
        <Switch>
          <Route path="/" component={Home} exact />
          <Route
            exact
            path="/case-studies/:slug"
            component={CaseStudyDetails}
          />
          <Route path="/case-studies" component={CaseStudies} />
          <Route path="/contact-us" component={RequestForQuote} />
          <Route path="/grievance" component={Grievance} />
          <Route
            path="/be-work-from-home-ready"
            component={BeWorkFromHomeReady}
          />
          <Route path="/faqs" component={FAQs} />
          <Route path="/outcess-clients" component={OutcessClients} />
          <Route path="/about" component={About} />
          <Route path="/industries" component={Industries} />
          <Route path="/business-partners" component={BusinessPartners} />
          <Route path="/ideology" component={Ideology} />
          <Route path="/careers" component={Careers} />
          <Route path="/hire/:id" component={Hire} />
          <Route path="/hireform" component={HireForm} />
          <Route path="/cloud-solutions" component={CloudSolutions} />
          <Route
            path="/omni-channel-marketing"
            component={OmniChannelMarketing}
          />
          <Route path="/current-openings" component={CurrentOpenings} />
          <Route path="/gallery" component={Gallery} />
          <Route
            path="/business-productivity-solutions"
            component={BusinessProdSolution}
          />
          <Route
            path="/business-process-outsourcing"
            component={BusinessOutsource}
          />
          <Route
            path="/customer-engagement-solutions"
            component={CustomerEngmntSolution}
          />
          <Route path="/agentic-ai" component={AgenticAi} />
          <Route path="/ai-debt-recovery" component={AIDebtRecovery} />
          <Redirect from="/gallary" to="/gallery" />
          <Redirect from="/customer-engagement-Solutions" to="/customer-engagement-solutions" />
          <Redirect from="/agenticAi" to="/agentic-ai" />
          <Redirect from="/aIDebtRecovery" to="/ai-debt-recovery" />
          <Redirect from="/aiDebtRecovery" to="/ai-debt-recovery" />
          <Route
            path="/isoqualitystatement"
            component={ISOQualityPolicyStatement}
          />
          <Route path="/ismspolicystatement" component={ISMSPolicyStatement} />
          <Route path="/data-policy" component={DataPolicy} />
          <Route path="/aml-solutions" component={AmlSolution} />
          <Route path="/ai-governance-lifecycle" component={AIGovernanceLifecycle} />
          {/* <Route
            path="/transforming-customer-service-operations"
            component={TransformCSOperationsCaseStudy}
          /> */}
          <ErrorBoundary>
            <Route path="/us" component={Usa} exact />
            <Route path="/us/services" component={USAServices} />
            <Route path="/us/contact us" component={USAContactus} />
            <Route path="/us/about us" component={USAboutUs} />
            <Route path="/us/industries" component={USIndustries} />
          </ErrorBoundary>
          <Route component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
